import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import Button from '../components/ui/Button';
import mariePhoto from '../assets/team/marie.jpg';
import morganePhoto from '../assets/team/morgane.jpg';

const Contact: React.FC = () => {
  return (
    <article className="pt-24 pb-16 bg-neutral-offwhite">
      <SEOHead
        title="Nous contacter"
        description="Contactez Doux ce Moman — spa bébé et massage prénatal à Geneuille, Doubs (25). Téléphone, email et adresse."
        path="/contact"
      />
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <header className="text-center mb-16">
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-neutral-ink mb-6">
            Contactez-nous
          </h1>
          <p className="font-nunito text-neutral-body max-w-2xl mx-auto text-lg">
            Notre équipe est à votre écoute pour répondre à toutes vos questions et vous accompagner dans votre parcours de bien-être.
          </p>
        </header>

        {/* Notre équipe */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Marie */}
          <div className="bg-neutral-offwhite rounded-2xl p-6 md:p-8">
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-accent-rose">
                <img
                  src={mariePhoto}
                  alt="Marie Amet"
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-playfair text-xl font-bold text-neutral-ink mb-2">
                Marie Amet
              </h3>
              <p className="font-nunito text-neutral-body mb-4">
                Infirmière DE
              </p>
            </div>
          </div>

          {/* Morgane */}
          <div className="bg-neutral-offwhite rounded-2xl p-6 md:p-8">
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-accent-rose">
                <img
                  src={morganePhoto}
                  alt="Morgane Darbon"
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-playfair text-xl font-bold text-neutral-ink mb-2">
                Morgane Darbon
              </h3>
              <p className="font-nunito text-neutral-body mb-4">
                Infirmière DE
              </p>
            </div>
          </div>
        </section>

        {/* Informations de contact */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start mb-16">
          <div>
            <h2 className="font-playfair text-2xl md:text-3xl font-bold text-neutral-ink mb-8">
              Nos Coordonnées
            </h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <MapPin className="text-brand flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="font-playfair font-bold text-neutral-ink mb-1">Adresse</h3>
                  <p className="font-nunito text-neutral-body">
                    32 Rue Lyautey<br />
                    25870 Geneuille<br />
                    France
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Phone className="text-brand flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="font-playfair font-bold text-neutral-ink mb-1">Téléphone</h3>
                  <p className="font-nunito text-neutral-body">06 28 97 99 07</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Mail className="text-brand flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="font-playfair font-bold text-neutral-ink mb-1">Email</h3>
                  <p className="font-nunito text-neutral-body">contact@douxcemoman.fr</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Clock className="text-brand flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="font-playfair font-bold text-neutral-ink mb-1">Horaires d'ouverture</h3>
                  <div className="font-nunito text-neutral-body">
                    <p>Lundi - Vendredi : 9h00 - 18h00 : Sur rendez-vous</p>
                    <p>Samedi : Sur appel uniquement</p>
                    <p>Dimanche : Fermé</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <Button variant="primary" size="lg" to="/reservation">
                Prendre rendez-vous
              </Button>
            </div>
          </div>

          {/* Carte */}
          <div>
            <h2 className="font-playfair text-2xl md:text-3xl font-bold text-neutral-ink mb-8">
              Notre Localisation
            </h2>
            <div className="relative h-[400px] rounded-2xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2765.8!2d6.0758!3d47.3086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479234c1467f78e2d%3A0x409ce34b30ed750!2s32%20Rue%20Lyautey%2C%2025870%20Geneuille!5e0!3m2!1sfr!2sfr!4v1726148130000!5m2!1sfr!2sfr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </section>

        {/* Call to action FAQ */}
        <section className="bg-neutral-offwhite rounded-2xl p-8 md:p-12 mt-16 text-center">
          <h2 className="font-playfair text-2xl md:text-3xl font-bold text-neutral-ink mb-4">
            Vous avez des questions ?
          </h2>
          <p className="font-nunito text-neutral-body max-w-xl mx-auto mb-8">
            Consultez notre page FAQ pour trouver des réponses détaillées sur nos services, les contre-indications et les informations pratiques.
          </p>
          <Button to="/faq" variant="primary" size="lg">
            Consulter la FAQ
          </Button>
        </section>
      </div>
    </article>
  );
};

export default Contact;